import { library } from '@fortawesome/fontawesome-svg-core';
import {
    faAngleDown,
    faAngleLeft,
    faAngleRight,
    faArrowDown,
    faArrowDown19,
    faArrowDown91,
    faArrowDownAZ,
    faArrowDownZA,
    faArrowLeft as fasArrowLeft,
    faArrowLeftToLine,
    faArrowRight,
    faArrowRightToLine,
    faArrowUp,
    faArrowUpAZ,
    faArrowUpRightFromSquare,
    faArrowsRotate,
    faArrowsRotateReverse,
    faArrowsSpin,
    faAsterisk,
    faBan,
    faBars,
    faBarsFilter,
    faBatteryBolt,
    faBatteryFull,
    faBatteryHalf,
    faBell,
    faBolt,
    faBox,
    faBrowser,
    faCalendarDays as fasCalendarDays,
    faCamera,
    faCar,
    faCaretDown,
    faChargingStation,
    faChartLine as fasChartLine,
    faChartLineUp,
    faChartMixed,
    faChartSimple,
    faCheck as fasCheck,
    faChevronDoubleDown,
    faChevronDoubleUp,
    faChevronDoubleLeft,
    faChevronDoubleRight,
    faChevronDown as fasChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronUp as fasChevronUp,
    faCircle,
    faCircleBolt,
    faCircleCheck,
    faCircleInfo,
    faCirclePlay,
    faCircleSterling,
    faClone,
    faCommentDots,
    faCopy,
    faDash,
    faDownload as fasDownload,
    faEarthEurope,
    faEnvelope,
    faExpand,
    faExpandArrowsAlt,
    faCompress,
    faEye,
    faFileCsv,
    faFileExcel,
    faFileLines,
    faFilter,
    faFire as fasFire,
    faFlask,
    faFloppyDisk,
    faFloppyDiskCircleArrowRight,
    faGear as fasGear,
    faGrid2,
    faHandshake,
    faHeat,
    faHouse,
    faHouseChimneyWindow,
    faIndustry,
    faIndustryWindows,
    faInfo,
    faInfoCircle as fasInfoCircle,
    faLeaf,
    faLightbulb,
    faLightbulbOn as fasLightbulbOn,
    faList,
    faLock,
    faLockKeyhole,
    faLockOpen,
    faMapLocation,
    faMessagePlus,
    faMoon,
    faMusic,
    faNetworkWired,
    faNotebook as fasNotebook,
    faObjectGroup,
    faPaperPlane,
    faPaperPlaneTop,
    faPenToSquare,
    faPencil,
    faPercent,
    faPersonDigging,
    faPeopleLine,
    faPlay,
    faPlug,
    faPlus,
    faPodcast,
    faQuestion,
    faQuestionCircle as fasQuestionCircle,
    faRaindrops,
    faRightFromBracket,
    faRightToBracket,
    faRotateLeft,
    faRotateRight,
    faShare,
    faShuffle,
    faSolarPanel,
    faStar,
    faStop,
    faSun,
    faTable,
    faThumbTack,
    faThumbsDown,
    faThumbsUp,
    faTimes,
    faTrashCan,
    faTriangleExclamation,
    faTurnDown,
    faTurnUp,
    faUnlockKeyhole,
    faUpDownLeftRight,
    faUpRightAndDownLeftFromCenter,
    faUpRightFromSquare,
    faUserHelmetSafety,
    faUserTie,
    faUsers,
    faUtilityPole,
    faVideo as fasVideo,
    faVolume,
    faVolumeSlash,
    faWebhook,
    faWrench,
    faXmark,
    faLayerPlus,
    faGripDots,
    faCalculator,
    faGasPump,
    faGaugeSimpleHigh,
    faBallPile,
    faKey,
    faDatabase,
    faArrowUpRightAndArrowDownLeftFromCenter,
    faArrowRotateLeft,
    faFunction,
    faBookmark,
    faPen,
    faPenRuler,
    faRankingStar as fasRankingStar,
    faReply,
    faSack,
    faEllipsis,
    faSliders as fasSliders,
    faExclamationCircle,
    faFlag,
    faUnderline,
    faClock,
    faMagnifyingGlassMinus,
    faMagnifyingGlassPlus,
    faUser as fasUser,
    faSatelliteDish,
    faRabbitRunning,
    faSync,
    faSparkles,
    faArrowUpTriangleSquare,
    faCaretUp,
    faDisplayChartUp,
    faShareNodes as fasShareNodes,
    faCode,
    faCodeCompare,
    faSignal,
    faPowerOff,
    faUpload,
    faCalendarLinesPen,
    faCircleXmark,
    faArrowTurnDownLeft,
    faChevronsLeft,
    faGraduationCap,
    faTableList,
    faBuilding as faBuildingSolid,
    faUserGroup,
    faSpinner,
    faBook,
    faUserSecret,
    faGlobe,
    faWandMagicSparkles,
    faNewspaper as fasNewspaper,
    faRightLeft,
    faComment,
    faListCheck,
} from '@fortawesome/pro-solid-svg-icons';
import {
    faAnalytics,
    faArrowAltSquareUp,
    faArrowLeft,
    faBellOn,
    faBrakeWarning,
    faBuilding,
    faChartBar,
    faChartLine,
    faChartLineUp as fadChartLineUp,
    faChartScatter,
    faChartUser,
    faChevronDown,
    faChevronUp,
    faClock as fadClock,
    faColumns,
    faCrystalBall,
    faDownload,
    faFileSignature,
    faFileExport,
    faFire,
    faGear,
    faGears,
    faGlobeEurope,
    faHistory,
    faIndustryWindows as fadIndustryWindows,
    faInfoCircle,
    faLayerGroup,
    faLightbulbOn as fadLighbulbOn,
    faMagnifyingGlass,
    faMapMarkedAlt,
    faMapPin,
    faNewspaper,
    faNotebook,
    faQuestionCircle,
    faExclamationCircle as fadExclamationCircle,
    faRankingStar,
    faRss,
    faSearch as fadSearch,
    faShareNodes,
    faSliders,
    faSunCloud,
    faTable as fadTable,
    faTh,
    faThList,
    faTrophy,
    faUser,
    faVideo,
    faWindTurbine,
    faHouse as fadHouse,
    faRectangleHistory,
    faScaleUnbalanced,
    faClipboardList,
    faMobile,
} from '@fortawesome/pro-duotone-svg-icons';

import { faTwitter, faLinkedin, faSlack } from '@fortawesome/free-brands-svg-icons';

import {
    faArrowCircleLeft,
    faCalendarDays,
    faChartArea,
    faCheck,
    faCloudArrowDown,
    faCloudArrowUp,
    faClipboard,
    faFile,
    faFilterSlash,
    faImage,
    faMagnifyingGlassChart,
    faMinus,
    faPrint,
    faSearch,
    faSquare,
    faSquareCheck,
    faBroomWide,
    faFilter as farFilter,
    faClock as farClock,
    faBookmark as farBookmark,
} from '@fortawesome/pro-regular-svg-icons';
import { faInputNumeric, faInputText } from '@fortawesome/pro-light-svg-icons';

// import {

// } from '@fortawesome/pro-regular-svg-icons';

library.add(
    faAnalytics,
    faAngleDown,
    faAngleLeft,
    faAngleRight,
    faArrowAltSquareUp,
    faArrowCircleLeft,
    faArrowDown,
    faArrowDown19,
    faArrowDown91,
    faArrowDownAZ,
    faArrowDownZA,
    faArrowLeft,
    faArrowLeftToLine,
    faArrowRightToLine,
    faArrowRight,
    faArrowUp,
    faArrowUpAZ,
    faArrowUpRightFromSquare,
    faArrowsRotate,
    faArrowsRotateReverse,
    faArrowsSpin,
    faAsterisk,
    faBallPile,
    faBan,
    faBars,
    faBarsFilter,
    faBatteryBolt,
    faBatteryFull,
    faBatteryHalf,
    faBell,
    faBellOn,
    faBolt,
    faBox,
    faBrakeWarning,
    faBroomWide,
    faBrowser,
    faBuilding,
    faCalendarDays,
    faCamera,
    faCar,
    faCaretDown,
    faChargingStation,
    faChartArea,
    faChartBar,
    faChartLine,
    faChartLineUp,
    faChartMixed,
    faChartScatter,
    faChartSimple,
    faChartUser,
    faCheck,
    faChevronDoubleDown,
    faChevronDoubleUp,
    faChevronDoubleLeft,
    faChevronDoubleRight,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faCircle,
    faCircleBolt,
    faCircleCheck,
    faCircleInfo,
    faCirclePlay,
    faCircleSterling,
    faClipboard,
    faClipboardList,
    faClock,
    fadClock,
    faClone,
    faCloudArrowDown,
    faCloudArrowUp,
    faColumns,
    faCommentDots,
    faCopy,
    faCrystalBall,
    faDash,
    faDownload,
    faEarthEurope,
    faEnvelope,
    faExclamationCircle,
    faExpand,
    faExpandArrowsAlt,
    faCompress,
    faEye,
    faFile,
    faFileCsv,
    faFileExcel,
    faFileLines,
    faFileExport,
    faFileSignature,
    faFilter,
    faFilterSlash,
    faFire,
    faFlask,
    faFloppyDisk,
    faDisplayChartUp,
    faFloppyDiskCircleArrowRight,
    faGaugeSimpleHigh,
    faGear,
    faGears,
    faGlobeEurope,
    faGrid2,
    faHandshake,
    faHeat,
    faHistory,
    faHouse,
    faHouseChimneyWindow,
    faImage,
    faIndustry,
    faIndustryWindows,
    faInfo,
    faInfoCircle,
    faLayerGroup,
    faLeaf,
    faLightbulb,
    faLinkedin,
    faList,
    faListCheck,
    faLock,
    faLockKeyhole,
    faLockOpen,
    faMagnifyingGlass,
    faMagnifyingGlassChart,
    faMagnifyingGlassMinus,
    faMagnifyingGlassPlus,
    faMapLocation,
    faMapMarkedAlt,
    faMapPin,
    faMessagePlus,
    faMinus,
    faMobile,
    faMoon,
    faMusic,
    faNetworkWired,
    faNewspaper,
    faNotebook,
    fasNotebook,
    faObjectGroup,
    faPaperPlane,
    faPaperPlaneTop,
    faPenToSquare,
    faPencil,
    faPercent,
    faPersonDigging,
    faPeopleLine,
    faPlay,
    faPlug,
    faPlus,
    faPodcast,
    faPrint,
    faQuestion,
    faQuestionCircle,
    fadExclamationCircle,
    faRaindrops,
    faRankingStar,
    faRightFromBracket,
    faRightToBracket,
    faRotateLeft,
    faRotateRight,
    faRss,
    faScaleUnbalanced,
    faSearch,
    faShare,
    faShareNodes,
    faShuffle,
    faSlack,
    faSliders,
    faSolarPanel,
    faSpinner,
    faSquare,
    faSquareCheck,
    faStar,
    faStop,
    faSun,
    faSunCloud,
    faTable,
    fadTable,
    faTh,
    faThList,
    faThumbTack,
    faThumbsDown,
    faThumbsUp,
    faTimes,
    faTrashCan,
    faTriangleExclamation,
    faTrophy,
    faTurnDown,
    faTurnUp,
    faTwitter,
    faUnlockKeyhole,
    faUpDownLeftRight,
    faUpRightAndDownLeftFromCenter,
    faUpRightFromSquare,
    faUser,
    faUserHelmetSafety,
    faUserTie,
    faUsers,
    faUtilityPole,
    faVideo,
    faVolume,
    faVolumeSlash,
    faWebhook,
    faWindTurbine,
    faWrench,
    faXmark,
    fadChartLineUp,
    fadHouse,
    fadIndustryWindows,
    fadLighbulbOn,
    fadSearch,
    farFilter,
    fasArrowLeft,
    fasCalendarDays,
    fasChartLine,
    fasCheck,
    fasChevronDown,
    fasChevronUp,
    fasDownload,
    fasFire,
    fasGear,
    fasInfoCircle,
    fasLightbulbOn,
    fasRankingStar,
    fasQuestionCircle,
    fasVideo,
    faRectangleHistory,
    faLayerPlus,
    faGripDots,
    faCalculator,
    faGasPump,
    faKey,
    faIndustryWindows,
    faDatabase,
    faArrowUpRightAndArrowDownLeftFromCenter,
    faArrowRotateLeft,
    faFunction,
    faPen,
    faPenRuler,
    faInputText,
    faInputNumeric,
    faReply,
    faSack,
    faEllipsis,
    fasSliders,
    faExclamationCircle,
    faFlag,
    faUnderline,
    fasUser,
    farClock,
    faSatelliteDish,
    faRabbitRunning,
    faSync,
    faArrowUpTriangleSquare,
    faCaretUp,
    faSparkles,
    fasShareNodes,
    faCode,
    faCodeCompare,
    faSignal,
    faPowerOff,
    faUpload,
    faCalendarLinesPen,
    faCircleXmark,
    faArrowTurnDownLeft,
    faChevronsLeft,
    faGraduationCap,
    faTableList,
    faBuildingSolid,
    faUserGroup,
    faBook,
    faUserSecret,
    fasNewspaper,
    faGlobe,
    faBookmark,
    farBookmark,
    faWandMagicSparkles,
    faRightLeft,
    faComment,
);
